
import RsLink from "components/Buttons/rsLink";
import React, { Component } from "react"
import { Row, Col, Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap"

class FooterLogin extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isPrivacy: false,
            isTerms: false,
        }
        this.togglePrivacyPolicy = this.togglePrivacyPolicy.bind(this);
        this.toggleTermsPolicy = this.toggleTermsPolicy.bind(this);
    }
    togglePrivacyPolicy() {
        this.setState(prevState => ({
            isPrivacy: !prevState.isPrivacy
        }));
    }
     toggleTermsPolicy() {
        this.setState(prevState => ({
            isTerms: !prevState.isTerms
        }));
    }

    render() {
        return (
            <React.Fragment>
                <footer className="footer" style={{ left: 0, background: 'rgba(0,0,0,0.5)' }}>
                    <div className="container-fluid">
                        <Row>
                            <Col sm={6}>
                                <RsLink to="#" className="text-white" iconClass="" onClick={this.togglePrivacyPolicy}>Privacy Policy</RsLink> {" "} <RsLink to="#" onClick={this.toggleTermsPolicy} className="text-white" iconClass="">Term of Use</RsLink>
                            </Col>
                            <Col sm={6}>
                                <div className="text-sm-end d-none d-sm-block">

                                </div>
                            </Col>
                        </Row>
                    </div>
                </footer>
                <Offcanvas
                    isOpen={this.state.isPrivacy}
                    direction="end"
                    toggle={this.togglePrivacyPolicy}
                    style={{ width: 600 }}
                >
                    <OffcanvasHeader toggle={this.togglePrivacyPolicy}>
                        Privacy Policy
                    </OffcanvasHeader>
                    <OffcanvasBody>

                    <div className="terms-container">
      

      <section>
        <h2>1. Introduction</h2>
        <p>
          At Realty Space (operated by 1978778 Ontario Inc.), we are committed to protecting your privacy and handling your personal information in a transparent and secure manner.
        </p>
        <p>
          This Privacy Policy applies to all users of Realty Space, including website visitors, platform subscribers (such as agents and brokerages), and end users accessing the Client Portal.
        </p>
        <p>
          This Privacy Policy explains how we collect, use, disclose, and safeguard information when you:
        </p>
        <ul>
          <li>Visit our website (www.realtyspace.co)</li>
          <li>Request a demo or contact us</li>
          <li>Use our Agent, Office, or Client Portal platforms</li>
          <li>Interact with our services in any other way</li>
        </ul>
        <p>
          By using our website or services, you agree to the terms of this Privacy Policy.
        </p>
      </section>

      <hr />

      <section>
        <h2>2. Information We Collect</h2>
        <p>
          We collect different types of information depending on how you interact with Realty Space.
        </p>

        <h3>2.1 Information You Provide Directly</h3>
        <p>You may provide us with personal information when you:</p>
        <ul>
          <li>Request a demo</li>
          <li>Contact us</li>
          <li>Create an account</li>
          <li>Subscribe to our services</li>
          <li>Communicate with support</li>
        </ul>
        <p>This may include:</p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Brokerage or company details</li>
          <li>Billing and payment information</li>
          <li>Any information you voluntarily submit</li>
        </ul>

        <h3>2.2 Platform Data Submitted by Subscribers</h3>
        <p>
          If you are a user of our platform (Agent or Office Portal), you may upload or manage data, including:
        </p>
        <ul>
          <li>Leads, contacts, and client information</li>
          <li>Property and transaction details</li>
          <li>Pre-construction project data</li>
          <li>Documents and files</li>
          <li>Communication records</li>
          <li>Scheduling and appointment information</li>
        </ul>
        <p>This data is referred to as Customer Data.</p>

        <h3>2.3 Client Portal User Data</h3>
        <p>If you access the Client Portal, we may collect:</p>
        <ul>
          <li>Profile and contact information</li>
          <li>Property preferences</li>
          <li>Transaction-related inputs</li>
          <li>Portal usage activity</li>
        </ul>

        <h3>2.4 Automatically Collected Information</h3>
        <p>
          When you use our website or platform, we may automatically collect:
        </p>
        <ul>
          <li>IP address</li>
          <li>Device and browser information</li>
          <li>Pages visited and interactions</li>
          <li>Login timestamps and activity logs</li>
          <li>Cookies and tracking data</li>
        </ul>
      </section>

      <hr />

      <section>
        <h2>3. How We Use Information</h2>
        <p>We use collected information to:</p>
        <ul>
          <li>Provide, operate, and maintain our platform</li>
          <li>Create and manage user accounts</li>
          <li>Process subscriptions and payments</li>
          <li>Deliver communications, notifications, and updates</li>
          <li>Respond to inquiries and provide support</li>
          <li>Improve platform functionality and user experience</li>
          <li>Monitor usage, prevent fraud, and ensure security</li>
          <li>Comply with legal and regulatory obligations</li>
        </ul>
      </section>

      <hr />

      <section>
        <h2>4. Customer Data and Role of Realty Space</h2>
        <p>
          Realty Space provides software tools to real estate professionals.
        </p>
        <ul>
          <li>
            Platform users (agents, brokerages, or offices) control the Customer Data they upload into the system.
          </li>
          <li>
            Realty Space processes this data solely to provide and improve the services.
          </li>
        </ul>
        <p>
          We do not independently use Customer Data for marketing or unrelated purposes.
        </p>
      </section>

      <hr />

      <section>
        <h2>5. Client Portal Data Clarification</h2>
        <p>
          Information presented in the Client Portal is provided and controlled by the real estate professional or brokerage using Realty Space.
        </p>
        <p>
          Realty Space does not verify the accuracy of this information and acts only as a technology platform facilitating access.
        </p>
      </section>

      <hr />

      <section>
        <h2>6. How We Share Information</h2>
        <p>We may share information with:</p>
        <ul>
          <li>Service providers (e.g., cloud hosting, payment processing, communication services)</li>
          <li>Analytics providers to improve performance</li>
          <li>Legal authorities where required by law</li>
          <li>Business successors in the event of a merger, sale, or restructuring</li>
        </ul>
        <p>We do not sell personal information.</p>
      </section>

      <hr />

      <section>
        <h2>7. Third-Party Integrations</h2>
        <p>
          Realty Space may integrate with third-party services such as email providers, communication platforms, and other tools.
        </p>
        <ul>
          <li>These integrations may involve the exchange of data with third-party systems</li>
          <li>Use of such services is subject to their own terms and privacy policies</li>
          <li>Realty Space is not responsible for third-party practices</li>
        </ul>
      </section>

      <hr />

      <section>
        <h2>8. Cookies and Tracking Technologies</h2>
        <p>We use cookies and similar technologies to:</p>
        <ul>
          <li>Ensure website functionality</li>
          <li>Analyze traffic and usage</li>
          <li>Improve user experience</li>
        </ul>
        <p>You can control cookie preferences through your browser settings.</p>
      </section>

      <hr />

      <section>
        <h2>9. Data Retention</h2>
        <p>We retain personal information only as long as necessary to:</p>
        <ul>
          <li>Provide services</li>
          <li>Comply with legal obligations</li>
          <li>Resolve disputes</li>
        </ul>
        <p>
          Account-related data may be retained for a limited period after account closure for backup, compliance, and operational purposes.
        </p>
      </section>

      <hr />

      <section>
        <h2>10. Data Security</h2>
        <p>
          We implement reasonable administrative, technical, and physical safeguards to protect your information.
        </p>
        <p>These measures include:</p>
        <ul>
          <li>Secure hosting infrastructure</li>
          <li>Access controls</li>
          <li>Monitoring and protection against unauthorized access</li>
        </ul>
        <p>However, no system can be guaranteed to be completely secure.</p>
      </section>

      <hr />

      <section>
        <h2>11. Cross-Border Data Transfers</h2>
        <p>
          Your information may be stored or processed in jurisdictions outside your province or country, including where our service providers operate.
        </p>
        <p>
          We take reasonable steps to ensure appropriate safeguards are in place.
        </p>
      </section>

      <hr />

      <section>
        <h2>12. Your Rights</h2>
        <p>Depending on your location, you may have rights to:</p>
        <ul>
          <li>Access your personal information</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Withdraw consent for certain uses</li>
        </ul>
        <p>
          To exercise these rights, you may contact us using the details below.
        </p>
      </section>

      <hr />

      <section>
        <h2>13. Children’s Privacy</h2>
        <p>
          Our services are not intended for individuals under the age of 18, and we do not knowingly collect personal information from minors.
        </p>
      </section>

      <hr />

      <section>
        <h2>14. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Updates will be posted on this page with a revised effective date.
        </p>
      </section>

      <hr />

      <section>
        <h2>15. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy or your personal information, please contact us at:
        </p>
        <p>Email: support@realtyspace.co</p>
        <p>Company: 1978778 Ontario Inc.</p>
        <p>Website: www.realtyspace.co</p>
      </section>
    </div>


                    </OffcanvasBody>
                </Offcanvas>

                  <Offcanvas
                    isOpen={this.state.isTerms}
                    direction="end"
                    toggle={this.toggleTermsPolicy}
                    style={{ width: 600 }}
                >
                    <OffcanvasHeader toggle={this.toggleTermsPolicy}>
                       Terms of Use
                    </OffcanvasHeader>
                    <OffcanvasBody>
                    <div className="terms-container" style={{ padding: "20px", lineHeight: "1.6" }}>
      

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          These Client Portal Terms of Use (“Terms”) govern your access to and use of the Realty Space Client Portal (the “Portal”), operated by 1978778 Ontario Inc. (“Realty Space”, “we”, “us”, or “our”).
        </p>
        <p>
          By accessing or using the Portal, you agree to be bound by these Terms. If you do not agree, you should not use the Portal.
        </p>
      </section>

      <hr />

      <section>
        <h2>2. Role of Realty Space</h2>
        <p>
          Realty Space provides a technology platform designed to facilitate communication and information sharing between real estate professionals and their clients.
        </p>
        <p>Realty Space is not:</p>
        <ul>
          <li>A real estate brokerage</li>
          <li>A real estate agent</li>
          <li>A legal advisor</li>
          <li>A financial or mortgage advisor</li>
        </ul>
        <p>
          Realty Space does not participate in, manage, or advise on real estate transactions.
        </p>
      </section>

      <hr />

      <section>
        <h2>3. Relationship with Your Real Estate Professional</h2>
        <p>The Portal is provided to you by your real estate agent or brokerage.</p>
        <ul>
          <li>Your relationship is solely with your agent or brokerage</li>
          <li>
            Realty Space is not a party to any agreement, transaction, or relationship between you and your agent
          </li>
        </ul>
        <p>
          All questions regarding listings, offers, transactions, or advice should be directed to your agent or brokerage.
        </p>
      </section>

      <hr />

      <section>
        <h2>4. Information Accuracy</h2>
        <p>
          Information displayed in the Portal, including property details, transaction information, and communications, is provided by your real estate professional.
        </p>
        <p>
          Realty Space does not verify the accuracy, completeness, or reliability of this information.
        </p>
      </section>

      <hr />

      <section>
        <h2>5. Use of the Portal</h2>
        <p>You agree to:</p>
        <ul>
          <li>Use the Portal for lawful purposes only</li>
          <li>Provide accurate information when requested</li>
          <li>Maintain the confidentiality of your login credentials</li>
        </ul>

        <p>You agree not to:</p>
        <ul>
          <li>Attempt to gain unauthorized access to the system</li>
          <li>Interfere with the operation of the Portal</li>
          <li>Use the Portal for fraudulent or unlawful purposes</li>
        </ul>
      </section>

      <hr />

      <section>
        <h2>6. Communications</h2>
        <p>By using the Portal, you may receive communications such as:</p>
        <ul>
          <li>Property updates</li>
          <li>Appointment notifications</li>
          <li>Transaction-related messages</li>
        </ul>
        <p>
          These communications are facilitated by Realty Space on behalf of your real estate professional.
        </p>
      </section>

      <hr />

      <section>
        <h2>7. No Professional Advice</h2>
        <p>
          The Portal may include tools, comparisons, or insights to assist you.
        </p>
        <p>
          These are provided for informational purposes only and do not constitute legal, financial, or real estate advice.
        </p>
        <p>
          You should consult your real estate agent or other professionals before making decisions.
        </p>
      </section>

      <hr />

      <section>
        <h2>8. Limitation of Liability</h2>
        <p>To the fullest extent permitted by law, Realty Space shall not be liable for:</p>
        <ul>
          <li>Decisions made based on information in the Portal</li>
          <li>Errors or omissions in content provided by your agent</li>
          <li>Any outcomes related to real estate transactions</li>
        </ul>
      </section>

      <hr />

      <section>
        <h2>9. Disclaimer of Warranties</h2>
        <p>
          The Portal is provided “as is” and “as available” without warranties of any kind.
        </p>
        <p>Realty Space does not guarantee:</p>
        <ul>
          <li>Continuous or uninterrupted access</li>
          <li>Accuracy of information</li>
          <li>Suitability for specific purposes</li>
        </ul>
      </section>

      <hr />

      <section>
        <h2>10. Privacy</h2>
        <p>
          Your use of the Portal is also governed by the Realty Space Privacy Policy.
        </p>
      </section>

      <hr />

      <section>
        <h2>11. Suspension or Termination</h2>
        <p>Access to the Portal may be suspended or terminated:</p>
        <ul>
          <li>By your real estate professional</li>
          <li>By Realty Space for security or misuse reasons</li>
        </ul>
      </section>

      <hr />

      <section>
        <h2>12. Changes to These Terms</h2>
        <p>
          We may update these Terms from time to time. Continued use of the Portal constitutes acceptance of the updated Terms.
        </p>
      </section>

      <hr />

      <section>
        <h2>13. Governing Law</h2>
        <p>
          These Terms are governed by the laws of the Province of Ontario and applicable Canadian laws.
        </p>
      </section>

      <hr />

      <section>
        <h2>14. Contact Us</h2>
        <p>If you have questions about these Terms, please contact:</p>
        <p>Email: support@realtyspace.co</p>
        <p>Company: 1978778 Ontario Inc.</p>
        <p>Website: www.realtyspace.co</p>
      </section>
    </div>



                    </OffcanvasBody>
                </Offcanvas>
            </React.Fragment>
        )
    }
}

export default FooterLogin;